"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.controller("mktHistoryExportPopinCtrl", function ($scope, $fileDownload, $uiBlock) {
  var labeledReferences = $scope.labeledReferences;
  var exportParams = $scope.exportParams;
  var andSpread = $scope.andSpread;

  // pour avoir un pas journalier quoi qu'il arrive
  exportParams.nbDonneeMax = -1;
  $scope.performExport = function () {
    $uiBlock.block();
    $fileDownload.start("/rest/market/history/export?xls=true", {
      labeledReferences: labeledReferences,
      andSpread: andSpread,
      options: exportParams
    }, {
      method: "POST"
    }).then(function () {
      $scope.$close();
    }).finally(function () {
      $uiBlock.unblock();
    });
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/marche/historique/mktHistoryExportPopin.js
// module id = 2849
// module chunks = 13